'use client';

import { forwardRef } from 'react';
import type { ReactNode } from 'react';
import { Box as MantineBox, createPolymorphicComponent } from '@mantine/core';
import type { BoxProps as MantineBoxProps } from '@mantine/core';

type BoxProps = MantineBoxProps & { children?: ReactNode };

const _Box = forwardRef<HTMLDivElement, BoxProps>((props, ref) => {
  return <MantineBox ref={ref} {...props} />;
});

_Box.displayName = 'Box';

export const Box = createPolymorphicComponent<'div', BoxProps>(_Box);
